export enum LoginForm{
    loginFormTitle = 'Prijava',
    loginPlaceholderUername='Korisničko ime',
    loginPlaceholderPassword='Lozinka',
    loginFormSubmitButton = 'Prijavi se',
    loginFormForrgotPasswordLink = 'Zaboravili ste lozinku?',
    loginFormSignUpLink = 'Registrujte se',
}